module.exports = __webpack_public_path__ + "static/media/social1Col.d97e1d11.png";